// Register the <state-drawer> element like native theme SearchDrawer
if (!customElements.get('state-drawer')) {
  class StateDrawer extends DrawerComponent {
    // keep the markup in place instead of re-appending to <body>
    get requiresBodyAppended() { return false; }
  }
  customElements.define('state-drawer', StateDrawer);
}

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('StateDrawer');
  if (!drawer) return; // not on this page

  // Wire up picker inputs/buttons
  const input   = drawer.querySelector('#StateSearchInput');
  const list    = drawer.querySelector('#StateList');
  const saveBtn = drawer.querySelector('#SaveStateBtn');
  if (!input || !list || !saveBtn) return; // missing template

  // header text element (desktop or mobile)
  const headerText = document.querySelector('.current-state-text');
  function updateHeaderText(code) {
    if (!headerText) return;
    headerText.textContent = code ? `${code}` : 'State';
  }
  // expose to state-select.js
  window.StateSelect = window.StateSelect || {};
  StateSelect.updateHeaderText = updateHeaderText;

  // initialize from cookie
  const stored = StateSelect.getCookie('selectedState');
  let pending = '';
  if (stored) {
    pending = stored;
    updateHeaderText(stored);
    const btn = list.querySelector(`button[data-code="${stored}"]`);
    if (btn) input.value = btn.textContent;
  } else {
    updateHeaderText('');
  }

  // filter dropdown
  function filterList() {
    const q = input.value.toLowerCase().trim();
    let any = false;
    list.querySelectorAll('button[data-code]').forEach(btn => {
      const ok = q === '' || btn.textContent.toLowerCase().includes(q);
      btn.style.display = ok ? 'block' : 'none';
      if (ok) any = true;
    });
    list.style.display = any ? 'block' : 'none';
  }
  input.addEventListener('click', filterList);
  input.addEventListener('input', () => {
    if (input.value.trim() === '') pending = '';
    filterList();
  });

  // pick a state
  list.addEventListener('click', e => {
    const btn = e.target.closest('button[data-code]');
    if (!btn) return;
    pending = btn.dataset.code;
    input.value = btn.textContent;
    list.style.display = 'none';
  });

  // save/clear
  saveBtn.addEventListener('click', () => {
    if (!pending) {
      StateSelect.setCookie('selectedState','',-1);
    } else {
      StateSelect.setCookie('selectedState', pending, 365);
    }
    updateHeaderText(pending);
    // let the theme close it for us
    ;(drawer.hide || drawer.close || (() => drawer.removeAttribute('open'))).call(drawer);
    StateSelect.setCookie(TIP_COOKIE, '1', TIP_DAYS);
    location.reload();
  });
});